import { render, staticRenderFns } from "./PageMap.vue?vue&type=template&id=3fa351d0&"
import script from "./PageMap.vue?vue&type=script&lang=js&"
export * from "./PageMap.vue?vue&type=script&lang=js&"
import style0 from "./PageMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports